import {
  Component,
  ElementRef,
  Optional,
  Self, ViewChild,
} from '@angular/core';
import moment from 'moment';
import { NgControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldControl, MatFormField, MatLabel, MatHint, MatSuffix, MatError } from '@angular/material/form-field';
import {ErrorStateMatcher, ShowOnDirtyErrorStateMatcher} from '@angular/material/core';
import { MatBaseInputComponent } from '../mat-base-input.component';
import { NGX_MAT_DATE_FORMATS, NgxMatDateFormats, NgxMatDatepickerInput, NgxMatDatetimepicker } from '@ngxmc/datetime-picker';
import { MatFormFieldFix } from '../mat-form-field/mat-form-field-fix';
import { NgClass, NgIf } from '@angular/common';
import { MatInput } from '@angular/material/input';
import { MatDatepickerToggle } from '@angular/material/datepicker';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

const DEFAULT_DATE_INPUT = {
  year: 'numeric', month: '2-digit', day: 'numeric',
  hour12: true, hour: '2-digit', minute: '2-digit'
};

const CUSTOM_DATE_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: DEFAULT_DATE_INPUT
  },
  display: {
    dateInput: DEFAULT_DATE_INPUT,
    monthYearLabel: {year: 'numeric', month: 'short'},
    dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
    monthYearA11yLabel: {year: 'numeric', month: 'long'},
  }
};

@Component({
    selector: 'app-mat-datetime-input',
    providers: [
        { provide: MatFormFieldControl, useExisting: MatDatetimeInputComponent },
        { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
        { provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }
    ],
    template: `
    <mat-form-field class="regular-form-field" [ngClass]="{'inline': inlineLabel, 'no-label': hideLabel}"
                    [hintLabel]="hintLabel"
                    [appearance]="appearance"
                    [hideRequiredMarker]="hideRequiredMarker || hideLabel"
                    (focusin)="onFocusIn($event)"
                    (focusout)="onFocusOut($event)">
      <mat-label *ngIf="!inlineLabel">
        {{label}}
      </mat-label>

      <input matInput
             [ngxMatDatetimePicker]="datePicker"
             (keyup)="onKeyUp($event)"
             (dateChange)="onDateChanged($event)"
             [formControl]="formControl"
             [id]="_id"
             [name]="name"
             [placeholder]="placeholder ? placeholder : inlineLabel ? label : ''"
             [autocomplete]="autocomplete"
      >
      <mat-hint>{{dateFormat}} {{timeFormat}}</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="$any(datePicker)"></mat-datepicker-toggle>
      <ngx-mat-datetime-picker #datePicker [enableMeridian]="true">
        <ng-template>
          <span>Select</span>
        </ng-template>
      </ngx-mat-datetime-picker>

      <mat-icon matSuffix class="explanation" *ngIf="!!explanation" matTooltip="{{explanation}}">info_outline</mat-icon>
      <mat-error *ngIf="formControl?.invalid">{{firstError()}}</mat-error>
    </mat-form-field>
  `,
    styles: [
        '.label-text {vertical-align: middle;}'
    ],
    standalone: true,
    imports: [MatFormField, MatFormFieldFix, NgClass, NgIf, MatLabel, MatInput, NgxMatDatepickerInput, FormsModule, ReactiveFormsModule, MatHint, MatDatepickerToggle, MatSuffix, NgxMatDatetimepicker, MatIcon, MatTooltip, MatError]
})
export class MatDatetimeInputComponent extends MatBaseInputComponent {

  @ViewChild('datePicker') datePicker;
  dateFormat: string;
  timeFormat: string;

  constructor(@Optional() @Self() public ngControl: NgControl, public _elementRef: ElementRef<HTMLElement>) {
    super(ngControl, _elementRef);

    const currentLocale = moment.localeData();
    this.dateFormat = currentLocale.longDateFormat('L');
    this.timeFormat = currentLocale.longDateFormat('LT');
  }

  onDateChanged($event) {
    this.valueChanged.emit($event.value);

    this.onTouched();
    this.propagateChange($event.value);
  }
}
